import { SvgIcon } from '@y42/core/icon';
import { JobStatus } from '@y42/json-schema';

export enum StatusName {
  New = 'New',
  Queued = 'Queued',
  Pending = 'Pending',
  Ready = 'Ready',
  Invalid = 'Invalid',
  PartiallyInvalid = 'Partially Invalid',
  PartiallyEmpty = 'Partially Empty',
  PartiallyReady = 'Partially Ready',
  Expired = 'Expired',
  Canceled = 'Canceled',
  NoJob = 'No Job',
  Untouched = 'Not Built',
  Waiting = 'Waiting',
}

export const iconPath = 'assets/images/job-status-icons/';
export const jobReady: SvgIcon = 'job-ready.svg';
export const jobReadyDark: SvgIcon = 'job-ready-dark.svg';
export const jobNew: SvgIcon = 'job-new.svg';
export const jobQueued: SvgIcon = 'job-queued.svg';
export const jobQueuedDark: SvgIcon = 'job-queued-dark.svg';
export const jobPending: SvgIcon = 'job-pending.svg';
export const jobPendingDark: SvgIcon = 'job-pending-dark.svg';
export const jobInvalid: SvgIcon = 'job-invalid.svg';
export const jobInvalidDark: SvgIcon = 'job-invalid-dark.svg';
export const jobPartiallyInvalid: SvgIcon = 'job-partially-invalid.svg';
export const jobPartiallyEmpty: SvgIcon = 'job-partially-empty.svg';
export const jobPartiallyReady: SvgIcon = 'job-partially-ready.svg';
export const jobPartiallyReadyDark: SvgIcon = 'job-partially-ready-dark.svg';
export const jobExpired: SvgIcon = 'job-expired.svg';
export const jobExpiredDark: SvgIcon = 'job-expired.svg';
export const jobCanceled: SvgIcon = 'job-canceled.svg';
export const jobCanceledDark: SvgIcon = 'job-canceled-dark.svg';
export const noJob: SvgIcon = 'no-job.svg';
export const noJobDark: SvgIcon = 'no-job-dark.svg';
export const jobNotBuilt: SvgIcon = 'job-not-built.svg';
export const jobWaiting: SvgIcon = 'job-waiting.svg';

export const noJobIcon: SvgIcon = `${iconPath}${noJob}`;
export const noJobIconDark: SvgIcon = `${iconPath}${noJobDark}`;
export const jobReadyIcon: SvgIcon = `${iconPath}${jobReady}`;

export const JobStatusToIcon: Record<
  JobStatus,
  {
    label: string;
    icon: SvgIcon;
    iconDark?: string;
  }
> = {
  [JobStatus.New]: {
    label: StatusName.New,
    icon: `${iconPath}${jobNew}`,
  },
  [JobStatus.Queued]: {
    label: StatusName.Queued,
    icon: `${iconPath}${jobQueued}`,
    iconDark: `${iconPath}${jobQueuedDark}`,
  },
  [JobStatus.Pending]: {
    label: StatusName.Pending,
    icon: `${iconPath}${jobPending}`,
    iconDark: `${iconPath}${jobPendingDark}`,
  },
  [JobStatus.Ready]: {
    label: StatusName.Ready,
    icon: `${iconPath}${jobReady}`,
    iconDark: `${iconPath}${jobReadyDark}`,
  },
  [JobStatus.Invalid]: {
    label: StatusName.Invalid,
    icon: `${iconPath}${jobInvalid}`,
    iconDark: `${iconPath}${jobInvalidDark}`,
  },
  [JobStatus.InvalidPartial]: {
    label: StatusName.PartiallyInvalid,
    icon: `${iconPath}${jobPartiallyInvalid}`,
  },
  [JobStatus.PartiallyEmpty]: {
    label: StatusName.PartiallyEmpty,
    icon: `${iconPath}${jobPartiallyEmpty}`,
  },
  [JobStatus.PartiallyReady]: {
    label: StatusName.PartiallyReady,
    icon: `${iconPath}${jobPartiallyReady}`,
    iconDark: `${iconPath}${jobPartiallyReadyDark}`,
  },
  [JobStatus.Expired]: {
    label: StatusName.Expired,
    icon: `${iconPath}${jobExpired}`,
    iconDark: `${iconPath}${jobExpiredDark}`,
  },
  [JobStatus.Canceled]: {
    label: StatusName.Canceled,
    icon: `${iconPath}${jobCanceled}`,
    iconDark: `${iconPath}${jobCanceledDark}`,
  },
};
